import React from 'react';
import { DateTime } from 'luxon';
import packageJSON from '../../../../package.json';

const Footer = () => {
  return (
    <footer className={`main-footer`}>
      <strong>
        <span>Copyright &#169; {DateTime.now().toFormat('y')} </span>
        Slomins Inc.
        <span>.</span>
      </strong>
      <div className="float-right d-none d-sm-inline-block">
        <b>Version</b>
        <span>&nbsp;{packageJSON.version}</span>
      </div>
    </footer>
  );
};

export default Footer;
